import React from 'react';

export default function AboutUsModal({ isOpen, onClose }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                <div className="p-6">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-2xl font-bold text-gray-900">About Us</h2>
                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-gray-600 text-2xl font-bold leading-none"
                        >
                            ×
                        </button>
                    </div>

                    <div className="space-y-4 text-gray-700">
                        <div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">Who We Are</h3>
                            <p className="leading-relaxed">
                                Insta Appointment is a revolutionary app that allows real time communication between patients and providers. It contacts multiple providers near their selected location to find appointments quickly without the patient having to make multiple phone calls and waiting on hold. The app also allows providers to communicate with potential patients in real time making the process of making appointments very easy.
                            </p>
                        </div>

                        <div>
                            <h3 className="text-xl font-semibold text-gray-900 mb-2">How It Works</h3>
                            <h4 className="text-lg font-semibold text-blue-900 mb-1">For Patients</h4>
                            <p className="leading-relaxed">
                                If you are a patient or patient's representative, first make an account. Then you can request the type of specialty/medical service that you need and specify the the location as well as the time frame for  your appointment. Let our app do the magic. It will connect you with providers that can serve your needs and allow you to communicate in real time with the provider offices. 
                            </p>
                            <h4 className="text-lg font-semibold text-blue-900 mb-1 mt-4">For Providers</h4>
                            <p className="leading-relaxed">
                                If you are a provider office, please fill out the registration form. Once we receive the registration form, we will send you a security code which can be used to activate your account. Then you can add information about the providers, locations, and type of services you offer. After a simple registration process, you will start receiving patient requests for appointments through the app. The app will also allow  you to communicate with the patients in real time. The app will free up phone calls and staff time to efficiently grow your practice. 
                            </p>
                        </div>
                    </div>

                    <div className="mt-6 flex justify-end">
                        <button
                            onClick={onClose}
                            className="px-6 py-3 bg-teal-700 text-white font-medium rounded-md hover:bg-teal-800 transition-colors focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
